import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

export const GraphWrapper = styled.div<{paddingBottom?:number}>`
    position: absolute;
    bottom: ${props => props.paddingBottom?props.paddingBottom:0}px;
    left: 0;
    right: 0;
    z-index: 0;
    overflow:hidden;
  canvas {
    
  }
`;

export const GradiantOverlay = styled.div`
    position: absolute;
    bottom:0;
    left:0px;
    right:0px;
    z-index: 1;
    overflow:hidden;
    width:100%;
    height:100%;
    background:linear-gradient(0deg, rgba(255,255,255,1) 5%, rgba(39, 121, 130, 0) 50%);
`;
export const BottomFiller = styled.div`
    background:rgba(185, 212, 215, 1);
    height:30px;
    width:100%;
    margin-top: -2px ;

    ${mq(Devices.laptop)}{
        height:15px;
    }

    ${mq(Devices.mobile)}{
        height:20px;
    }
`;